module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/diseases/chest-bb3a6702ba9e869d2501445922b2b574.png";